/* eslint-disable react/no-unescaped-entities */
import { m } from 'framer-motion'
import { Link as RouterLink } from 'react-router-dom'
// components
import Page from '../../components/Page'
import ForbiddenIllustration from '../../assets/illustration_403'

// ----------------------------------------------------------------------

export default function Page403() {
    return (
        <Page title='403 Forbidden'>
            <div className="container mx-auto">
                <div className="max-w-lg mx-auto min-h-screen flex flex-col justify-center items-center py-12 px-4 text-center">
                    <m.div>
                        <h1 className="text-3xl font-bold mb-4">
                            No permission
                        </h1>
                    </m.div>

                    <m.div>
                        <p className="text-gray-600 mb-8">
                            The page you're trying access has restricted access.
                            <br />
                            Please refer to your system administrator
                        </p>
                    </m.div>

                    <m.div>
                        <ForbiddenIllustration className="h-64 my-8 md:my-10" />
                    </m.div>

                    <RouterLink to='/'>
                        <button className="px-6 py-2 bg-primary hover:bg-primary-hover text-white font-medium rounded-md transition-colors">
                            Go to Home
                        </button>
                    </RouterLink>
                </div>
            </div>
        </Page>
    )
}
